module.exports = __webpack_public_path__ + "img/style_0_6.50331b17.png";